import React, {FC} from 'react';
import {Link} from 'react-router-dom';
import {parseHtml} from '../../../utils/parseHtml';
import UITag from '../../UICommon/UITag';

type NewsItemMobileProps = {
  id: number;
  slug: string;
  image: string;
  title: string;
  byline: string;
  tag: string;
}

const NewsItemMobile: FC<NewsItemMobileProps> = ({
  id,
  slug,
  image,
  title,
  byline,
  tag,
}) => {
  const parsedByline = parseHtml(byline);
  return (
    <Link to={`/all-inclusive/news/${slug}`} id={`news-${id}`} className='w-full h-auto flex flex-col box'>
      <div className='h-[240px] relative'>
        <img className='h-full w-full object-cover rounded-t-15px' src={image} alt={title}/>
        <UITag name={tag} extraStyles='absolute -bottom-4 left-5'/>
      </div>
      <div className='h-auto'>
        <div className='bg-white px-5 pt-8 h-full flex flex-col pb-8 rounded-b-15px'>
          <h3 className='font-medium text-lg text-black-dark'>{title}</h3>
          <div className='text-black-dark/50 text-base news-content-wrapper'>
            <p>{parsedByline}</p>
          </div>
          <p className='text-pink-primary uppercase font-medium text-sm mt-4'>Läs mer</p>
        </div>
      </div>
    </Link>
  );
};

export default NewsItemMobile;
